import axios from 'axios';
import { supabase } from '../lib/supabase'; // Importando o cliente Supabase

// --- Interfaces ---

export interface Result {
  id: number;
  empresa: string;
  contato: string;
  localizacao: string;
  status: 'Validado' | 'Pendente' | 'Inválido';
  whatsapp: boolean;
  prospected: boolean;
  
  // Extended fields from SerpApi
  rating?: number;
  reviews?: number;
  website?: string;
  phone?: string;
  place_id?: string;
}

interface SearchParams {
  searchQuery: string;
  countryCode: string; 
  page?: number; // Agora é o número do CHUNK
}

// --- Main Search Function ---

export async function searchProspects(params: SearchParams): Promise<{ results: Result[], total: number, hasNextPage: boolean }> {
  const { searchQuery, countryCode, page = 1 } = params; 

  // 1. Obter o token de sessão do Supabase
  // Usamos getSession() para obter a sessão e o token de acesso.
  const { data: { session } } = await supabase.auth.getSession();
  
  if (!session || !session.user) {
    throw new Error('Usuário não autenticado.');
  }
  
  // 2. Chamar a Edge Function (Proxy)
  const functionUrl = `${process.env.REACT_APP_SUPABASE_URL}/functions/v1/search-prospects`;

  try {
    const response = await axios.post<{ results: Result[], total: number, hasNextPage: boolean }>(
      functionUrl,
      {
        searchQuery,
        countryCode, 
        page, // Enviando o número do chunk
      },
      {
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${session.access_token}`,
        },
        timeout: 60000 // Aumentando o timeout para 60s, pois a Edge Function fará 5 chamadas
      }
    );
    
    return response.data;
    
  } catch (error) {
    if (axios.isAxiosError(error) && error.response) {
      const status = error.response.status;
      const message = error.response.data?.message || error.response.data || 'Erro desconhecido na Edge Function.';
      
      if (status === 401) {
        throw new Error('Sessão expirada ou não autorizada.');
      }
      if (status === 400) {
        throw new Error(`Erro de Configuração: ${message}`);
      }
      
      // Novo tratamento para 503 (Timeout do Supabase)
      if (status === 503) {
        throw new Error('A busca excedeu o tempo limite do servidor (10 segundos). Tente uma busca mais específica ou um país diferente.');
      }
      
      throw new Error(`Falha na comunicação com o servidor: ${message}`);
    }
    
    throw new Error('Falha ao buscar prospects. Verifique a conexão.');
  }
}

// Funções utilitárias antigas (detectarIdiomaPais, normalizarTelefone, mapSerpApiToResults)
// são removidas daqui, pois a lógica de chamada e mapeamento agora deve residir na Edge Function.
// Mantemos apenas a interface Result.